import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import Markdown from "markdown-to-jsx";
var OilDetailsAccordion = function OilDetailsAccordion(_ref) {
  var section = _ref.section;
  var _useState = useState(null),
    openIdx = _useState[0],
    setOpenIdx = _useState[1];
  if (!section.content.length) return null;
  var toggle = function toggle(idx, btn) {
    // Keep the clicked header pinned in the viewport: collapsing a section
    // above it shifts layout up and would otherwise make the page jump.
    var before = btn.getBoundingClientRect().top;
    setOpenIdx(function (prev) {
      return prev === idx ? null : idx;
    });
    requestAnimationFrame(function () {
      var after = btn.getBoundingClientRect().top;
      if (after !== before) window.scrollBy(0, after - before);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 md:mt-0 mt-4 py-8 border-solid border-t border-[#E0E0E0] md:px-0 px-4"
  }, section.content.map(function (item, idx) {
    var isOpen = openIdx === idx;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "bg-white border border-solid border-[#E6E9EF] rounded-xl overflow-hidden"
    }, /*#__PURE__*/React.createElement("button", {
      className: "w-full flex items-center justify-between px-4 py-4 text-right cursor-pointer bg-transparent border-none gap-3",
      onClick: function onClick(e) {
        return toggle(idx, e.currentTarget);
      },
      "aria-expanded": isOpen
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 min-w-0"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.icon,
      alt: "",
      className: "w-5 h-5 md:w-7 md:h-7 object-contain flex-shrink-0"
    }), /*#__PURE__*/React.createElement("h2", {
      className: "font-bold text-[#1B2035] text-sm md:text-base truncate"
    }, item.title)), /*#__PURE__*/React.createElement("span", {
      className: "text-primary-new text-3xl md:text-3xl font-light leading-none flex-shrink-0"
    }, isOpen ? "−" : "+")), /*#__PURE__*/React.createElement("div", {
      className: "px-4 pb-5 pt-1 text-xs md:text-sm text-[#5A6880] leading-relaxed whitespace-pre-line border-solid border-t border-[#F1F6FC]".concat(isOpen ? "" : " hidden")
    }, /*#__PURE__*/React.createElement(Markdown, {
      options: {
        overrides: {
          table: {
            component: function component(_ref2) {
              var children = _ref2.children;
              return /*#__PURE__*/React.createElement("table", {
                className: "w-full border-collapse bg-[#F2F2F2] rounded-xl overflow-hidden [&_td]:px-4 [&_td]:py-3 [&_td]:text-sm [&_tr]:border-b [&_tr]:border-solid [&_tr]:border-[#E0E0E0] [&_tr:last-child]:border-0 [&_td:first-child]:!font-bold [&_td:first-child]:text-primary-new [&_td:first-child]:text-start [&_td:not(:first-child)]:text-[#5A6880] [&_td:not(:first-child)]:text-end"
              }, children);
            }
          },
          ul: {
            component: function component(_ref3) {
              var children = _ref3.children;
              return /*#__PURE__*/React.createElement("ul", {
                className: "list-disc px-8"
              }, children);
            }
          },
          ol: {
            component: function component(_ref4) {
              var children = _ref4.children;
              return /*#__PURE__*/React.createElement("ol", {
                className: "list-decimal px-8"
              }, children);
            }
          },
          thead: {
            component: function component() {
              return null;
            }
          }
        }
      }
    }, item.body)));
  }));
};
export default OilDetailsAccordion;